import { Component, Input, OnInit } from '@angular/core';
import { NotificationBlockStyle } from './notification-block.types';

@Component({
  selector: 'app-notification-block',
  templateUrl: './notification-block.component.html',
  styleUrls: ['./notification-block.component.scss'],
})
export class NotificationBlockComponent implements OnInit {
  @Input() text: string = '';
  @Input() style: NotificationBlockStyle = NotificationBlockStyle.INFO;

  public readonly styleColorsMap: Record<NotificationBlockStyle, string> = {
    [NotificationBlockStyle.SUCCESS]: 'color-state-success',
    [NotificationBlockStyle.WARNING]: 'color-state-warning',
    [NotificationBlockStyle.ERROR]: 'color-state-error',
    [NotificationBlockStyle.INFO]: 'color-primary-2',
  };

  constructor() {}

  ngOnInit() {
    return;
  }
}
